import React, {  Fragment } from 'react';
import styled from 'styled-components';
import PTSLogo from '../assets/nav-psharp.svg';
import HeaderTitle from '../assets/header-title.svg';
import Background from '../assets/header-background.svg';
import KaohsiungDefault from '../assets/kaohsiung-default.svg';
import KaohsiungYes from '../assets/kaoshiung-yes.svg';
import KaohsiungNo from '../assets/kaoshiung-no.svg';
import hamburgerIcon from '../assets/nav-hamburger.svg';
import { navSection, editorText } from '../editor/text';
import { FacebookShare, LineShare } from './ShareButtons';
import { LiveComponent } from './LiveHeader';
import { stage, setup, breakPoints, recallPossibleResults } from '../config';
import { autoScroll } from '../utils';

const { maxMobile } = breakPoints;
const { currentStage, recallResult } = setup;

const currentKaohsiungIconSrc = (() => {
  if (currentStage < stage.postLive) {
    return KaohsiungDefault;
  } else {
    if (recallResult === recallPossibleResults.yes) {
      return KaohsiungYes;
    } else if (recallResult === recallPossibleResults.no) {
      return KaohsiungNo;
    } else {
      return KaohsiungDefault;
    }
  }
})();


const height = '80px';
const backgroundHeight = currentStage >= stage.live ? '500px' : '486px';

const Container = styled.nav`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: ${height};
  display: flex;
  box-sizing: border-box;
  padding: 0 20px;
  justify-content: space-between;
  background-color: ${props => props.theme.blue};
  align-items: center;
`;

const BGImageWrapper = styled.div`
  width: 100%;
  height: 486px;
  position: relative;
  > img:first-child {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    height: 520px;
  }
  @media (max-width: 630px) {
    height: 560px;
  }
`;

const KaohsiungContainer = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
`;

const BGContentContainer = styled.div`
  position: absolute;
  z-index: 3;
  top: ${props => props.stage !== stage.live ? '60px' : '60px'};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: white;
  font-size: 16px;
  p {
    max-width: 488px;
  }
`;

const RightHalfDesktop = styled.div`
  display: flex;
  align-items: center;
  @media(max-width: ${maxMobile}px) {
    display: none;
  }
`;

const RightHalfMobile = styled.div`
  display: none;
  @media(max-width: ${maxMobile}px) {
    display: inline;
  }
  cursor: pointer;
  padding: 5px;
`

const IconWrapper = styled.div`
  margin-right: 20px;
`

const Text = styled.div`
  cursor: pointer;
  margin-right: 20px;
  color: white;
  font-size: 16px;
  &:link {
    color: white;
    text-decoration: none;
    transition: 0.3s;
    border-bottom: 1px solid transparent;
  }
  &:hover {
    color: white;
    transition: 0.3s;
    border-bottom: 1px solid white;
  }
  &:visited {
    color: white;
  }
`

const DisableText = styled.div`
  margin-right: 20px;
  color: white;
  font-size: 16px;
  cursor: not-allowed;
  color: ${props => props.theme.disableGray}
`

function Navbar({
  openMobileMenu,
}) {
  const onClickTextHandler = ({
    anchorId,
  }) => {
    // if (window && window.location && window.history) {
    //   const { location } = window;
    //   const { href, search } = location;
    //   // console.log('href: ', href)
    //   // console.log('search: ', search);
    //   const newHref = href.replace(search, '');
    //   window.history.replaceState(null, '', newHref);
    // }
    if (window) {
      autoScroll({
        targetId: anchorId,
      });
    }
  }
  const Texts = navSection.map(({
    text,
    anchorId,
    disable,
  }) => {
    if (disable) {
      return (
        <DisableText
          href={`#${anchorId}`}
          key={`nav_text_section_${anchorId}`}
        >
          {text}
        </DisableText>
      )
    }
    return (
      <Text
        href={`#${anchorId}`}
        key={`nav_text_section_${anchorId}`}
        onClick={() => {
          onClickTextHandler({
            anchorId,
          });
        }}
      >
        {text}
      </Text>
    )
  })

  return (
    <Fragment>
      <Container>
        <a
          href="https://newslab.pts.org.tw/news"
          alt="Public Television Service"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={PTSLogo}
            alt="Public Television Logo"
          />
        </a>
        <RightHalfDesktop>
          {Texts}
          <IconWrapper>
            <FacebookShare
              type="nav"
            />
          </IconWrapper>
          <LineShare
            type="nav"
          />
        </RightHalfDesktop>
        <RightHalfMobile
          onClick={openMobileMenu}
        >
          <img
            src={hamburgerIcon}
            alt="navsection hamburger"
          />
        </RightHalfMobile>
      </Container>
      <BGImageWrapper>
        <img src={Background} alt="background-blue" />
        <BGContentContainer
          stage={currentStage}
        >
          <LiveComponent />
          <h1
            style={{margin: '0'}}
          >
            <img
              style={{
                margin: '16px 0 0 0',
              }}
              src={HeaderTitle}
              alt="20200606 高雄市長罷免案 即時開票"
            />
          </h1>
          <div
            dangerouslySetInnerHTML={{__html: `${editorText.landing}`}}
          />
        </BGContentContainer>
        <KaohsiungContainer>
          <img src={currentKaohsiungIconSrc} alt="kaohsiung" />
        </KaohsiungContainer>
      </BGImageWrapper>
    </Fragment>
  )
}

export default Navbar;
